<div class="special-order-notifications-dialog">
  <div class="dialog-heading">
    <div>
      <h3>Avisos de Compras</h3>
      <p>Consulta fechas estimadas y items no considerados en recepción.</p>
    </div>
    <button mat-icon-button type="button" aria-label="Cerrar" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (loading()) {
    <div class="loading-state">
      <p-progressSpinner strokeWidth="4" [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
      <p>Cargando avisos…</p>
    </div>
  } @else if (errorMessage()) {
    <div class="error-state" role="alert">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage() }}</span>
      <button mat-stroked-button type="button" (click)="loadThreads()">Reintentar</button>
    </div>
  } @else if (!threads().length) {
    <div class="empty-state">
      <mat-icon>notifications_none</mat-icon>
      <p>No hay avisos pendientes.</p>
    </div>
  } @else {
    <div class="notification-layout">
      <section class="thread-list" aria-label="Avisos de Compras">
        @for (thread of threads(); track thread.id) {
          <button class="thread-card" type="button" [class.selected]="selectedThread()?.id === thread.id" (click)="selectThread(thread)">
            <span class="thread-card-header">
              <strong>{{ threadTitle(thread) }}</strong>
              @if (thread.unreadCount > 0) { <span class="unread-badge">{{ thread.unreadCount }}</span> }
            </span>
            @if (isUnconsideredThread(thread)) {
              <span class="thread-card-date">{{ threadSubtitle(thread) }}</span>
              <span class="thread-card-status">Item no considerado</span>
            } @else {
              <span class="thread-card-date thread-card-detail">Cliente: {{ threadCustomerName(thread) }}</span>
              <span class="thread-card-date thread-card-detail">Venta: {{ threadSalesPeople(thread) }}</span>
              <span class="thread-card-date thread-card-detail">Asignado a: {{ threadAssignedPerson(thread) }}</span>
              <span class="thread-card-date">Fecha estimada: {{ formatDate(thread.latestEvent?.afterDate) }}</span>
              <span class="thread-card-status">Estado: {{ threadStatusLabel(thread) }}</span>
            }
          </button>
        }
      </section>

      <section class="history-panel" aria-live="polite">
        @if (!selectedThread()) {
          <div class="empty-state compact"><mat-icon>touch_app</mat-icon><p>Selecciona un aviso para ver su historial.</p></div>
        } @else {
          <div class="history-heading">
            <div>
              <h4>{{ threadTitle(selectedThread()!) }}</h4>
              @if (isUnconsideredThread(selectedThread()!)) {
                <span>Compras debe empatar el SKU para que aparezca en Cotejar y etiquetar.</span>
              } @else {
                <span>Promesa se conserva como referencia en el seguimiento comercial.</span>
              }
            </div>
            <button mat-flat-button color="primary" type="button" (click)="openTracking(selectedThread()!)">
              <mat-icon>open_in_new</mat-icon>
              {{ isUnconsideredThread(selectedThread()!) ? 'Abrir recepción' : 'Abrir seguimiento' }}
            </button>
          </div>
          @if (!isUnconsideredThread(selectedThread()!) && !canOpenTracking()) { <p class="permission-note">Tu usuario puede consultar el aviso, pero no tiene permiso de ventas para abrir el seguimiento.</p> }
          @if (eventsLoading()) {
            <div class="loading-state compact"><p-progressSpinner strokeWidth="4" [style]="{ width: '32px', height: '32px' }"></p-progressSpinner></div>
          } @else {
            <div class="event-list">
              @for (event of events(); track event.id) {
                <article class="event-card">
                  <div class="event-card-header">
                    <strong>{{ isUnconsideredEvent(event) ? 'SKU reportado' : eventTypeLabel(event.eventType) }}</strong>
                    <small>{{ formatEventDate(event.createdAt) }}</small>
                  </div>
                  @if (isUnconsideredEvent(event)) {
                    <div class="event-meta">
                      <span>SKU: {{ eventSnapshotSku(event) || '—' }}</span>
                      @if (eventSnapshotReceipt(event)) {
                        <span>Recepción: {{ eventSnapshotReceipt(event) }}</span>
                      }
                      @if (eventSnapshotNote(event)) {
                        <span>Nota: {{ eventSnapshotNote(event) }}</span>
                      }
                      <span>Actor: {{ event.actorName || 'Sistema' }}</span>
                    </div>
                  } @else {
                    <div class="event-change">
                      <span>Antes: {{ formatDate(event.beforeDate) }}</span>
                      <mat-icon>arrow_forward</mat-icon>
                      <span>Ahora: {{ formatDate(event.afterDate) }}</span>
                    </div>
                    <div class="event-meta">
                      <span>Estado de fecha: {{ statusLabel(event.afterStatus) }}</span>
                      <span>Actor: {{ event.actorName || 'Sistema' }}</span>
                      @if (event.resultingVersion) { <span>Versión: {{ event.resultingVersion }}</span> }
                    </div>
                  }
                </article>
              } @empty {
                <p class="empty-history">No hay eventos visibles para este aviso.</p>
              }
            </div>
          }
        }
      </section>
    </div>
  }
</div>
